import React from 'react'
import injectSheet from 'react-jss'
import styles from './action-unmark-conclusion.styles'
import CheckIcon from 'react-icons/lib/fa/check'

const ActionUnmarkConclusion = ({ classes, id, name, timestamp }) => {
  return (
    <div className={classes.container}>
      <span className={classes.icon}>
        <CheckIcon />
      </span>{' '}
      <div>
        <strong className={classes.name}>{name}</strong>&nbsp;unmarked a
        contribution as a conclusion for this discussion {timestamp} ago
      </div>
    </div>
  )
}

export default injectSheet(styles)(ActionUnmarkConclusion)
